import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import LineChart from 'routes/vendorRe/components/LineChart';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import { requester } from 'App';

const StoreSettlementStatus = (props) => {
    const { storeId } = props;

    const [isMounted, setMounted] = useState(false);
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState();
    const [salesOverview, setSalesOverview] = useState();

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let storeData = { id: storeId };
            requester.getStoreWeeklySalesStatus(storeData, (result) => {

                setTotalWeekEachAmount(result.data);
            })
            requester.getVendorStoreSalesOverview(storeData, (result) => {

                setSalesOverview(result.data);
            })
        }
    }, [isMounted])

    return (
        <FlexChild backgroundColor="white" padding="1em" borderRadius="1em">
            <VerticalFlex>
                <FlexChild alignItems={"flex-start"} padding={"0 1em"}>
                    <P weight={600} size={"18px"}>매출현황</P>
                </FlexChild>
                <FlexChild padding={"2% 5%"}>
                    <LineChart totalWeekEachAmount={totalWeekEachAmount} />
                </FlexChild>
                <FlexChild padding={"2% 5%"}>
                    <HorizontalFlex gap={"15%"}>
                        <FlexChild>
                            <HorizontalFlex>
                                <FlexChild>
                                    <P weight={600} size={"14px"} color={"var(--main-color)"}>오늘 매출</P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P weight={600} size={"16px"} color={"var(--main-color)"}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0}원</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                            <HorizontalFlex>
                                <FlexChild>
                                    <P weight={600} size={"14px"} color={"rgba(98, 109, 125, 1)"}>이번주 매출</P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P weight={600} size={"16px"} color={"rgba(98, 109, 125, 1)"}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}원</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild padding={"2% 5%"}>
                    <HorizontalFlex gap={"15%"}> 
                        <FlexChild>
                            <HorizontalFlex>
                                <FlexChild>
                                    <P weight={600} size={"14px"} color={"rgba(98, 109, 125, 1)"}>이번달 매출</P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P weight={600} size={"16px"} color={"rgba(98, 109, 125, 1)"}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}원</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                            <HorizontalFlex>
                                <FlexChild>
                                    <P weight={600} size={"14px"} color={"rgba(98, 109, 125, 1)"}>올해 매출</P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P weight={600} size={"16px"} color={"rgba(98, 109, 125, 1)"}>{salesOverview ? salesOverview.thisYearTotalPrice.toLocaleString() : 0}원</P>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </VerticalFlex>
        </FlexChild>
    );
};

export default StoreSettlementStatus;